import PropTypes from 'prop-types';
import React, { cloneElement, useContext, useMemo } from 'react';

import classnames from 'classnames';
import styled from 'styled-components';

import { MainContext } from '@ezbobdev/ui-framework';

const Wrapper = styled.div`
  && {
    /* when a modal is rendered, hide all the elements after the Modal (like the table) */

    ${(props) =>
      !props.visibleBackground &&
      ` & ~ * {
                display: none;
            }
        `}
  }
`;

const Modal = (props) => {
  const { actions } = useContext(MainContext);
  const { modalName, beforeModal, afterModal, children, className, visibleBackground } = props;
  const modalView = actions.view.getView('modal');
  const isValidModal = modalView.modalName && modalView.props && modalView.modalName === modalName;

  return useMemo(
    () =>
      isValidModal ? (
        <Wrapper
          className={classnames('Modal', className)}
          visibleBackground={visibleBackground}
          data-testid={`${modalName}-modal`}
        >
          {beforeModal && <div className="before-modal">{beforeModal}</div>}
          {cloneElement(children, modalView.props)}
          {afterModal && <div className="after-modal">{afterModal}</div>}
        </Wrapper>
      ) : null,
    [isValidModal, children, modalView.props, className, beforeModal, afterModal, visibleBackground],
  );
};

Modal.propTypes = {
  modalName: PropTypes.string.isRequired,
  beforeModal: PropTypes.any,
  afterModal: PropTypes.any,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default React.memo(Modal);
